import React from 'react';
import styled from 'styled-components';

import {Divider} from '../../custom-feature/divider/Divider';
import {WithScrollContext} from '../../../page-structure/useScrollContext.tsx';

export const AsideRow = ({children, ...props}) => {
    const scrollRef = React.useRef(null);

    return (
        <WithScrollContext scrollRef={scrollRef}>
            {/* If a `ref` prop is passed, it is intentionally NOT forwarded here, but replaced by the scroll ref */}
            <AsideRowWrapper {...props} ref={scrollRef}>
                {children}
            </AsideRowWrapper>
        </WithScrollContext>
    );
};

export const AsideRowWrapper = styled.div`
    padding: var(--aside-padding);
    word-break: break-word;
    ${Divider} {
        margin: var(--aside-padding) calc(0px - var(--aside-padding));
        width: calc(100% + (var(--aside-padding) * 2));
    }
`;
